<div class="w-full flex justify-center px-2 sm:px-0 flex-1 min-h-0">
    <div
        class="relative w-full backdrop-blur-[81.54845428466797px] bg-white/10 rounded-[36px] z-10 max-w-[406px] min-h-[325px] h-full flex flex-col items-center pt-[170px] pb-[40px] px-[25px]">
        <div class="absolute top-[-120px] left-0 w-full flex justify-center">
            <img class="w-[65%]" [src]="info.icon" alt="">
        </div>
        <div class="font-outfit text-2xl font-semibold w-full text-center">{{info.title}}</div>
        <div class="font-inter text-base w-full text-center mt-[12px]">{{info.text}}</div>
    </div>
</div>